__turbopack_context__.v({
  "option": "Autocomplete-module-scss-module__Wap-eq__option",
  "option__helpText": "Autocomplete-module-scss-module__Wap-eq__option__helpText",
  "option__selected": "Autocomplete-module-scss-module__Wap-eq__option__selected",
  "option__title": "Autocomplete-module-scss-module__Wap-eq__option__title",
  "options": "Autocomplete-module-scss-module__Wap-eq__options",
  "optionsClosing": "Autocomplete-module-scss-module__Wap-eq__optionsClosing",
  "optionsOpening": "Autocomplete-module-scss-module__Wap-eq__optionsOpening",
  "options__list": "Autocomplete-module-scss-module__Wap-eq__options__list",
  "options__open": "Autocomplete-module-scss-module__Wap-eq__options__open",
  "root": "Autocomplete-module-scss-module__Wap-eq__root",
});
